export default __webpack_public_path__ + "static/media/Outdoors-1613434454409.318a273f.png";